import { render, staticRenderFns } from "./SelectApp.vue?vue&type=template&id=5ff0edf6&"
import script from "./SelectApp.vue?vue&type=script&lang=ts&"
export * from "./SelectApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff0edf6')) {
      api.createRecord('5ff0edf6', component.options)
    } else {
      api.reload('5ff0edf6', component.options)
    }
    module.hot.accept("./SelectApp.vue?vue&type=template&id=5ff0edf6&", function () {
      api.rerender('5ff0edf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectApp.vue"
export default component.exports